export default __webpack_public_path__ + "static/media/readme-lock.614e97e5.png";